const trimTrailingSlash = (value = "") => String(value || "").replace(/\/+$/, "");

const normalizeBase = (value, fallback = "") => {
  const raw = trimTrailingSlash(value || fallback);
  if (!raw) return "";
  try {
    const parsed = new URL(raw);
    return parsed.origin + trimTrailingSlash(parsed.pathname);
  } catch (error) {
    return raw;
  }
};

const ensureLeadingSlash = (value = "") => {
  const next = String(value || "");
  return next.startsWith("/") ? next : `/${next}`;
};

const dedupeApiPrefix = (base, path) => {
  if (/\/api$/i.test(base) && /^\/api(\/|$)/i.test(path)) {
    return path.replace(/^\/api/i, "");
  }
  return path;
};

const DEFAULT_API_BASE = "/api";

export const API_BASE = normalizeBase(process.env.REACT_APP_BASE, DEFAULT_API_BASE);
// Superadmin API must always hit ERP (/api). Do not inherit Booster base.
export const SUPERADMIN_BASE = API_BASE;

export const buildApiUrl = (path, base = API_BASE) => {
  const normalizedPath = ensureLeadingSlash(path);
  const normalizedBase = normalizeBase(base);
  if (!normalizedBase) {
    return normalizedPath;
  }
  const dedupedPath = dedupeApiPrefix(normalizedBase, normalizedPath);
  return `${normalizedBase}${dedupedPath}`;
};
